import { useState, useEffect, useCallback } from 'react';

/**
 * Hook pour gérer les filtres avec états temporaires pour les dates
 */
export const useFilters = (initialDateDebut, initialDateFin) => {
  const [filters, setFilters] = useState({
    dateDebut: initialDateDebut,
    dateFin: initialDateFin,
    fournisseurId: '',
    clientId: '',
    metalId: '',
    designation: '',
    achat: ''
  });
  
  const [tempDateDebut, setTempDateDebut] = useState(initialDateDebut);
  const [tempDateFin, setTempDateFin] = useState(initialDateFin);

  // Synchroniser les états temporaires avec les filtres
  useEffect(() => {
    setTempDateDebut(filters.dateDebut);
    setTempDateFin(filters.dateFin);
  }, [filters.dateDebut, filters.dateFin]);

  const handleDateDebutBlur = useCallback((e) => {
    const value = e?.target?.value || '';
    if (value !== tempDateDebut) {
      setTempDateDebut(value);
    }
    if (value !== filters.dateDebut) {
      setFilters(f => ({ ...f, dateDebut: value }));
    }
  }, [tempDateDebut, filters.dateDebut]);

  const handleDateFinBlur = useCallback((e) => {
    const value = e?.target?.value || '';
    if (value !== tempDateFin) {
      setTempDateFin(value);
    }
    if (value !== filters.dateFin) {
      setFilters(f => ({ ...f, dateFin: value }));
    }
  }, [tempDateFin, filters.dateFin]);

  const handleDateDebutKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const value = e.target?.value || '';
      if (value !== tempDateDebut) {
        setTempDateDebut(value);
      }
      if (value !== filters.dateDebut) {
        setFilters(f => ({ ...f, dateDebut: value }));
      }
      e.target.blur();
    }
  }, [tempDateDebut, filters.dateDebut]);

  const handleDateFinKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const value = e.target?.value || '';
      if (value !== tempDateFin) {
        setTempDateFin(value);
      }
      if (value !== filters.dateFin) {
        setFilters(f => ({ ...f, dateFin: value }));
      }
      e.target.blur();
    }
  }, [tempDateFin, filters.dateFin]);

  const resetFilters = useCallback((firstJan) => {
    setFilters({
      dateDebut: firstJan,
      dateFin: '',
      fournisseurId: '',
      clientId: '',
      metalId: '',
      designation: '',
      achat: ''
    });
    setTempDateDebut(firstJan);
    setTempDateFin('');
  }, []);

  return {
    filters,
    setFilters,
    tempDateDebut,
    setTempDateDebut,
    tempDateFin,
    setTempDateFin,
    handleDateDebutBlur,
    handleDateFinBlur,
    handleDateDebutKeyDown,
    handleDateFinKeyDown,
    resetFilters
  };
};
